import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面未找到 | 51爆料网",
    description: "你访问的页面可能已调整或尚未开放，请从栏目导航页重新选择需要的板块。",
    keywords: "51爆料网,页面未找到",
    canonical: location.pathname,
  });

  return (
    <section className="mx-auto flex max-w-[1280px] flex-col items-center px-6 py-24 text-center">
      <p className="font-heading text-6xl font-black text-primary-200 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        没有找到这个页面
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的地址 <span className="font-mono text-foreground-800">{location.pathname}</span> 可能已调整或尚未开放。
        可以返回首页，或直接到栏目导航页重新选择需要的板块。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/lanmu"
          className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-compass-3-line" />
          打开栏目导航
        </Link>
      </div>
    </section>
  );
}